import channelLayoutValues from './channel-layout-values';
import channelVideoListValues from './channel-video-list-values';
import COMPACT_PLAY_TYPE_VALUES from './compact-play-type';
import COMPACT_SHOW_VIDEO_LIST_VALUES from './compact-show-video-list';
import infoPositionValues from './info-position-values';
import layoutStyleValues from './layout-style-values';
import MAIN_ACTION_STYLE_TYPES from './main-action-style-types';
import mainItemTypeValues from './main-item-type-values';
import posterPositionValues from './poster-position-values';
import showInfoValues from './show-info-values';
import showMediaTypeValues from './show-media-type-values';
import titlePositionValues from './title-position-values';

export { channelLayoutValues };
export { channelVideoListValues };
export { COMPACT_PLAY_TYPE_VALUES };
export { COMPACT_SHOW_VIDEO_LIST_VALUES };
export { infoPositionValues };
export { layoutStyleValues };
export { MAIN_ACTION_STYLE_TYPES };
export { mainItemTypeValues };
export { posterPositionValues };
export { showInfoValues };
export { showMediaTypeValues };
export { titlePositionValues };

export default {
  booleans: {
    enableVideosSharing: true,
    showChannelCategories: true,
    showChannelShare: true,
    showChannelTitle: true,
    showChannelInfo: false,
    showSearch: true,
    showSignIn: true,
    showChannelTags: true,
    showChannelVideos: true,
    showFullInfo: true,
    showVideoPublisherInList: true,
    showVideoTitleInList: true,
    showTitleForMainItem: true,
    showPublisherForMainItem: true,
    showActionBar: true,
  },
  numbers: {
    videoInfoPosition: infoPositionValues.ON_VIDEOS,
    showInfoAction: showInfoValues.ON_MOUSE_OVER,
    layoutStyle: layoutStyleValues.SQUARE,
    channelLayout: channelLayoutValues.CLASSIC,
    mainItemType: mainItemTypeValues.CHANNEL_COVER,
    mainItemTitlePosition: titlePositionValues.CENTER,
    videoListVisibility: channelVideoListValues.EXPAND_ON_CLICK,
    videosInRow: 4,
    mainItemOverlayOpacity: 35,
    showMediaType: showMediaTypeValues.COVER_IMAGE,
    numberOfRows: 1,
    playType: COMPACT_PLAY_TYPE_VALUES.IN_FRAME,
    compactShowVideoListType: COMPACT_SHOW_VIDEO_LIST_VALUES.WHEN_CLICKED,
    mainActionStyleType: MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT,
  },
  editMode: 'site',
};



// WEBPACK FOOTER //
// ./src/default-settings/index.js